<template>
  <div id="table-actions">
    
    <div class="actions-right">
      <span v-if="showDelete" id="assets-list-delete" class="action" @click="handleOnDelete">
        <v-icon small class="mr-1" color="secondary" v-text="'mdi-trash-can-outline'"></v-icon>
        {{$t('assets-page-option-delete')}}
      </span>

      <span v-if="showHide" id="assets-list-hide" class="action" @click="onHideDeselected">
        <v-icon small class="mr-1" color="secondary" v-text="hide ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"></v-icon>
        {{$t(hideText)}}
      </span>

      <span v-if="showExport" id="assets-list-export" class="action" @click="$emit('on-export')">
        <v-icon small class="mr-1" color="secondary" v-text="'mdi-close-box'"></v-icon>
        {{$t('assets-page-option-export')}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'panel',
  props: {
    showDelete: {
      type: Boolean,
      default: true,
    },
    showHide: {
      type: Boolean,
      default: true,
    },
    showExport: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      hide: false,
      hideText: 'assets-page-option-hide-deselected',
    };
  },
  methods: {
    onHideDeselected() {
      this.hide = !this.hide;
      if (this.hide) this.hideText = 'assets-page-option-show-all';
      else this.hideText = 'assets-page-option-hide-deselected';
      this.$emit('on-hide-deselected', this.hide);
    },
    handleOnDelete() {
      this.$emit('on-delete');
    },
  },
};
</script>
<style lang="scss" scoped>
#table-actions {
  font-size: 13px;
  color: var(--v-primary-darken2);
}

.actions-right {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 14px;
  padding: 6px 12px 6px 12px; /* que no quede pegado al borde */
}

.action {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 6px 8px;
  border-radius: 4px;
}

.action:hover {
  background: rgba(0, 0, 0, 0.04);
}

.option-disabled {
  color: gray;
  cursor: not-allowed;
}

</style>